import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PROVIDED_JOB_POST_LISTS_QUERY_KEY } from './useProvidedJobPostLists';

type CreateParams = {
  name: string;
  isPublic: boolean;
  providedJobPostIds?: number[];
};

export default function useCreateProvidedJobPostList() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ name, isPublic, providedJobPostIds }: CreateParams) => {
      const csrfToken =
        document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
      const response = await fetch('/agent/api/provided_job_post_lists.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': csrfToken,
        },
        body: JSON.stringify({
          provided_job_post_list: { name, is_public: isPublic },
          provided_job_post_ids: providedJobPostIds,
        }),
      });
      if (!response.ok) {
        let errorMessage = 'Failed to create list';
        try {
          const error = await response.json();
          errorMessage = error.error || errorMessage;
        } catch {
          // JSONパースに失敗した場合はデフォルトメッセージを使用
        }
        throw new Error(errorMessage);
      }
      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PROVIDED_JOB_POST_LISTS_QUERY_KEY] });
    },
  });
}
